import { ObjectSchema, array, boolean, number, object, string } from "yup";
import {
  fileCollectionValidation,
  requiredClassifierId,
  requiredString,
  stringTiming,
} from "../../../../data/yupConstants";
import { SubmitCreation } from "../../../../generated/data-contracts";
import { CreationType, ResCallback } from "../../../../models";

export const validationSchema = (
  selectedCreationClassCode: CreationType,
  uploadableFileTypes: string[] | undefined,
  unsupportedSymbols: string[],
  maxFileSize: number,
  res: ResCallback,
): ObjectSchema<SubmitCreation> | undefined => {
  const validationSchema: ObjectSchema<SubmitCreation> = object({
    creationClassId: requiredClassifierId(res),
    creationGenreId: number().when([], {
      is: () => ["M", "PPI"].indexOf(selectedCreationClassCode) > -1,
      then: (schema) => schema.required(res("validation_FieldIsRequired")),
    }),
    timings: stringTiming(res).when([], {
      is: () => ["M", "H"].indexOf(selectedCreationClassCode) > -1,
      then: (schema) => schema.required(res("validation_FieldIsRequired")),
    }),
    manufactureYear: string(),
    publisher: string().max(100),
    isbnNumber: string().max(50),
    creationName: requiredString(res).max(200),
    creationAlternativeName: string().max(200),
    notes: string().max(500),
    creationBands: array().of(
      object().shape({
        entertainerOrGroup: requiredString(res),
      }),
    ),
    rightsHolders: array().of(
      object().shape({
        isCurrentRightsHolder: boolean(),
        additionalInformation: requiredString(res).max(100),
        creationRoleId: requiredClassifierId(res),
      }),
    ),
    creationFiles: fileCollectionValidation(
      res,
      uploadableFileTypes,
      unsupportedSymbols,
      maxFileSize,
    ),
  });

  return validationSchema;
};
